import { Badge, Button, InputAdornment, Stack, TextField } from '@mui/material';
import Iconify from 'src/components/iconify';

import SearchIcon from '@mui/icons-material/Search';
import { GridToolbarColumnsButton, GridToolbarDensitySelector } from '@mui/x-data-grid';
import TableStatusFilter, {
  type TableStatusFilterOption,
} from 'src/components/table/table-status-filter';
import type { BenefitStatusFilterValue } from './benefits-drawer-filters.hook';

const STATUS_FILTER_OPTIONS = [
  { label: 'Ativo', value: 'active', color: 'success' },
  { label: 'Inativo', value: 'inactive', color: 'error' },
  { label: 'Expirado', value: 'expired', color: 'error' },
  { label: 'Esgotado', value: 'soldOut', color: 'warning' },
] as const satisfies readonly TableStatusFilterOption<BenefitStatusFilterValue>[];

type BenefitsTableToolbarProps = {
  searchText: string;
  selectedFiltersCount: number;
  statusFilters?: BenefitStatusFilterValue[];
  statusFiltersDisabled?: boolean;
  handleClickFilters: () => void;
  onStatusFiltersChange?: (values: BenefitStatusFilterValue[]) => void;
  setSearchText: (value: string) => void;
};

export function BenefitsTableToolbar({
  searchText,
  selectedFiltersCount,
  statusFilters,
  statusFiltersDisabled,
  handleClickFilters,
  onStatusFiltersChange,
  setSearchText,
}: BenefitsTableToolbarProps) {
  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      flexWrap="wrap"
      useFlexGap
      spacing={1}
      width="100%"
    >
      <Stack direction="row" spacing={1} alignItems="center">
        <TextField
          placeholder="Pesquisar..."
          variant="standard"
          size="small"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon fontSize="small" sx={{ color: 'text.primary' }} />
              </InputAdornment>
            ),
            disableUnderline: false,
          }}
          sx={{
            minWidth: 250,
            '& input': {
              color: 'text.primary',
              opacity: 0.8,
            },
          }}
        />
      </Stack>

      <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap" useFlexGap>
        {onStatusFiltersChange && (
          <TableStatusFilter
            options={STATUS_FILTER_OPTIONS}
            values={statusFilters || []}
            onChange={onStatusFiltersChange}
            disabled={statusFiltersDisabled}
          />
        )}

        <Stack direction="row" spacing={0.5}>
          <Button
            size="small"
            startIcon={
              <Badge
                color="primary"
                badgeContent={selectedFiltersCount}
                invisible={selectedFiltersCount === 0}
                overlap="circular"
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                sx={{
                  '& .MuiBadge-badge': {
                    minWidth: 20,
                    height: 20,
                    fontSize: '0.65rem',
                    padding: '0 4px',
                  },
                }}
              >
                <Iconify icon="mdi:filter-variant" />
              </Badge>
            }
            onClick={handleClickFilters}
          >
            Filtros
          </Button>
          <GridToolbarColumnsButton />
          <GridToolbarDensitySelector />
        </Stack>
      </Stack>
    </Stack>
  );
}
